export var DynamicComponentIOCheck = /*#__PURE__*/function (DynamicComponentIOCheck) {
  DynamicComponentIOCheck["Validate"] = "Validate";
  DynamicComponentIOCheck["FilterUnknown"] = "FilterUnknown";
  DynamicComponentIOCheck["None"] = "None";
  return DynamicComponentIOCheck;
}(DynamicComponentIOCheck || {});